import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import {  useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import useFormHook from "@shared/hooks/useFormHook";
import { identificatorsService } from "@modules/additionalSettings/nomenclatures/services/identificators";
import { notifySuccess, notifyError } from "@config/tostifyConfig/tostifyConfig";

export default function IndentificatorSecondForm({ onClose, nomstruct, modalType, onSuccess, selectedDeterm, fetchNomstruct }) {
    const { modalRef } = useFormHook({}, onClose);
    const { t } = useTranslation();
    const { register, handleSubmit, setValue, reset } = useForm();
    const [isActiveChecked, setIsActiveChecked] = useState(false);
    const [loading, setLoading] = useState(false);

    // Set form values when editing
    useEffect(() => {
        if (modalType === 'edit' && nomstruct) {
            setValue('mnemonic', nomstruct.mnemonic);
            setValue('partsize', nomstruct.partsize);
            setValue('name', nomstruct.name);
            setIsActiveChecked(nomstruct.active || false);
            setValue('active', nomstruct.active || false);
        }
    }, [modalType, nomstruct, setValue]);

    const submitForm = async (data) => {
        if (!selectedDeterm) {
            notifyError('No determ selected');
            return;
        }

        setLoading(true);
        try {
            const nomstructData = {
                mnemonic: selectedDeterm.mnemonic, // Use mnemonic from selected determ
                partsize: parseInt(data.partsize),
                name: data.name,
                determId: selectedDeterm.mnemonic // Use mnemonic as determId
            };

            if (modalType === 'edit' && nomstruct) {
                await identificatorsService.updateNomstruct(nomstruct.id, nomstructData);
                notifySuccess(t('common.updatedSuccessfully'));
            } else {
                await identificatorsService.createNomstruct(nomstructData);
                notifySuccess(t('common.createdSuccessfully'));
            }

            // Refetch the nomstruct data for the currently selected determ
            if (selectedDeterm && selectedDeterm.id) {
                await fetchNomstruct(selectedDeterm.id);
            }
            onSuccess();
            onClose();
        } catch (error) {
            console.error('Error saving nomstruct:', error);
            notifyError(error?.response?.data?.message || t('common.errorMessage'));
        } finally {
            setLoading(false);
        }
    }

    const handleClose = (e) => {
        if (modalRef.current === e.target) {
            onClose();
        }
    }

    const handleIsActiveChange = (e) => {
        setIsActiveChecked(e.target.checked);
        setValue('active', e.target.checked);
    }

    return (
        <div className="modal show" tabIndex="-1" onClick={handleClose}>
            <div className="modal-dialog modal-confirm" ref={modalRef}>
                <div className="modal-content">
                    <button type="button" className="close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <div className="modal-body">
                        <h4 className="modal-title">
                            {modalType === 'edit' ? t('common.edit') : t('common.add')} {t('additionalSettings.identificators.levels')}
                        </h4>
                        <form id="indentificatorForm" className="region-form" onSubmit={handleSubmit(submitForm)}>
                            <div className="flex-column">
                                <div className="form-section">
                                    <div className="form-group">
                                        <span className="span-bold">{t('additionalSettings.identificators.form.value')} <span className="required">*</span></span>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            {...register('partsize', { required: true, min: 1 })} 
                                        />
                                    </div>
                                    <div className="form-group">
                                        <span className="span-bold">{t('additionalSettings.identificators.form.title')} <span className="required">*</span></span>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            {...register('name', { required: true })} 
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button 
                            type="submit" 
                            form="indentificatorForm" 
                            className="btn btn-primary"
                            disabled={loading}
                        >
                            {t('common.save')}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            {t('common.cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}